<template>
  <div class="container">
    <div class="header">
      <h3>{{$t('signup.confirmationNotReceivedheader')}}</h3>
    </div>
    <div class="fieldsContainer">
      <p>{{$t('signup.confirmationResendInformation')}}
      </p>
      <div class="input">
          <input id="emailField" v-model="emailInput" v-on:keyup.enter="resend" class="themeInput" type="text" placeholder="e-mail" autofocus>
          <font-awesome-icon icon="envelope" class="inputImage"/>
      </div>        
      
      <div v-if="errorMessage" class="w3-panel errorBox w3-round">
        {{ errorMessage }} 
        <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
      </div>
    </div>
    <div>
      <button class="button-default" @click="resend">{{$t('signup.resend')}}</button>
    </div>  
    <div class="bottomLogo"><h4><img class="logo-c" :src="knightC" >hess Administrator</h4></div>
  </div>

</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/Authentication/ResendConfirmation';

export default {
  name: 'EmailConfirmResend',
  data: function () {
    return {
      emailInput: "",
      errorMessage: "",
    }
  },
  methods: {
    resend: function() {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.emailInput,
        response: false,
      };
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log("Resend succesfully requested." + JSON.stringify(response));
          that.$router.push("/sign-in?confirmationawaiting=mail");
        })
        .catch(error => {
          that.errorMessage = error.response.data.errors;
          console.log("Error: " + JSON.stringify(error.response));
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .input {
    padding-top: 1em;
  }

  .buttons {
    margin-top: 1em;
  }

.input {
  margin-bottom: 10px;
  display: flex; 
  align-items: stretch;
  padding-top: 10px;
  position: relative;
}

.inputImage {
  font-size:28px;
  padding: 5px;
  border-style: hidden;
  z-index: 1;
  position: absolute;
  right: 2px;
}

/* mobile */
@media screen and (max-width: 600px) {

  .container {
    width: 90vw;
  }

.resend {
    width: 70vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .input {
    padding-top: 1em;
  }

  .buttons {
    margin-top: 1em;
  }

  .container {
    width: 300px;
    margin-top: 10vh;
  }

.resend {
    width: 30vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .input {
    padding-top: 1em;
  }

  .buttons {
    margin-top: 1em;
  }

  .container {
    width: 400px;
    margin-top: 10vh;
  }
  
  .resend {
    width: 30vw;
  }
}
</style>
